/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SyncRunResultDTO
 */
export interface SyncRunResultDTO {
  /**
   *
   * @type {number}
   * @memberof SyncRunResultDTO
   */
  runId: number;
  /**
   *
   * @type {number}
   * @memberof SyncRunResultDTO
   */
  platformId: number;
  /**
   *
   * @type {string}
   * @memberof SyncRunResultDTO
   */
  triggeredBy: SyncRunResultDTOTriggeredByEnum;
  /**
   *
   * @type {string}
   * @memberof SyncRunResultDTO
   */
  status: SyncRunResultDTOStatusEnum;
  /**
   *
   * @type {string}
   * @memberof SyncRunResultDTO
   */
  startedAt: string;
  /**
   *
   * @type {Date}
   * @memberof SyncRunResultDTO
   */
  finishedAt?: Date | null;
  /**
   * The moment this run synced from (= startedAt of the previous successful run for this platform); null = initial full population.
   * @type {Date}
   * @memberof SyncRunResultDTO
   */
  syncFromMoment?: Date | null;
  /**
   *
   * @type {number}
   * @memberof SyncRunResultDTO
   */
  pagesCreated: number;
  /**
   *
   * @type {number}
   * @memberof SyncRunResultDTO
   */
  pagesSetOnline: number;
  /**
   *
   * @type {number}
   * @memberof SyncRunResultDTO
   */
  pagesSetOffline: number;
  /**
   * Number of pages where the grace period started this run (`noDealsSince` was set).
   * @type {number}
   * @memberof SyncRunResultDTO
   */
  pagesSetPendingOffline: number;
  /**
   * Number of pages whose grace period was reset this run (deals reappeared, so `noDealsSince` was cleared).
   * @type {number}
   * @memberof SyncRunResultDTO
   */
  pagesResetGrace: number;
  /**
   *
   * @type {number}
   * @memberof SyncRunResultDTO
   */
  pagesDeleted: number;
  /**
   *
   * @type {number}
   * @memberof SyncRunResultDTO
   */
  errorCount: number;
  /**
   *
   * @type {string}
   * @memberof SyncRunResultDTO
   */
  errorMessage?: string | null;
}

/**
 * @export
 */
export const SyncRunResultDTOTriggeredByEnum = {
  CRON: "CRON",
  ADMIN: "ADMIN"
} as const;
export type SyncRunResultDTOTriggeredByEnum =
  typeof SyncRunResultDTOTriggeredByEnum[keyof typeof SyncRunResultDTOTriggeredByEnum];

/**
 * @export
 */
export const SyncRunResultDTOStatusEnum = {
  RUNNING: "RUNNING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
} as const;
export type SyncRunResultDTOStatusEnum = typeof SyncRunResultDTOStatusEnum[keyof typeof SyncRunResultDTOStatusEnum];

/**
 * Check if a given object implements the SyncRunResultDTO interface.
 */
export function instanceOfSyncRunResultDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "runId" in value;
  isInstance = isInstance && "platformId" in value;
  isInstance = isInstance && "triggeredBy" in value;
  isInstance = isInstance && "status" in value;
  isInstance = isInstance && "startedAt" in value;
  isInstance = isInstance && "pagesCreated" in value;
  isInstance = isInstance && "pagesSetOnline" in value;
  isInstance = isInstance && "pagesSetOffline" in value;
  isInstance = isInstance && "pagesSetPendingOffline" in value;
  isInstance = isInstance && "pagesResetGrace" in value;
  isInstance = isInstance && "pagesDeleted" in value;
  isInstance = isInstance && "errorCount" in value;

  return isInstance;
}

export function SyncRunResultDTOFromJSON(json: any): SyncRunResultDTO {
  return SyncRunResultDTOFromJSONTyped(json, false);
}

export function SyncRunResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncRunResultDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    runId: json["runId"],
    platformId: json["platformId"],
    triggeredBy: json["triggeredBy"],
    status: json["status"],
    startedAt: json["startedAt"],
    finishedAt: !exists(json, "finishedAt")
      ? undefined
      : json["finishedAt"] === null
      ? null
      : new Date(json["finishedAt"]),
    syncFromMoment: !exists(json, "syncFromMoment")
      ? undefined
      : json["syncFromMoment"] === null
      ? null
      : new Date(json["syncFromMoment"]),
    pagesCreated: json["pagesCreated"],
    pagesSetOnline: json["pagesSetOnline"],
    pagesSetOffline: json["pagesSetOffline"],
    pagesSetPendingOffline: json["pagesSetPendingOffline"],
    pagesResetGrace: json["pagesResetGrace"],
    pagesDeleted: json["pagesDeleted"],
    errorCount: json["errorCount"],
    errorMessage: !exists(json, "errorMessage") ? undefined : json["errorMessage"]
  };
}

export function SyncRunResultDTOToJSON(value?: SyncRunResultDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    runId: value.runId,
    platformId: value.platformId,
    triggeredBy: value.triggeredBy,
    status: value.status,
    startedAt: value.startedAt,
    finishedAt:
      value.finishedAt === undefined ? undefined : value.finishedAt === null ? null : value.finishedAt.toISOString(),
    syncFromMoment:
      value.syncFromMoment === undefined
        ? undefined
        : value.syncFromMoment === null
        ? null
        : value.syncFromMoment.toISOString(),
    pagesCreated: value.pagesCreated,
    pagesSetOnline: value.pagesSetOnline,
    pagesSetOffline: value.pagesSetOffline,
    pagesSetPendingOffline: value.pagesSetPendingOffline,
    pagesResetGrace: value.pagesResetGrace,
    pagesDeleted: value.pagesDeleted,
    errorCount: value.errorCount,
    errorMessage: value.errorMessage
  };
}
